<!-- Ported from the Polaris kit: src/components/ui/attachment/Attachment.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';
import { attachmentVariants } from '.';

const props = defineProps({
  size: { type: null, required: false, default: 'default' },
  orientation: { type: null, required: false, default: 'horizontal' },
  state: { type: String, required: false, default: 'done' },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="attachment"
    :data-state="state"
    :data-size="size"
    :data-orientation="orientation"
    :class="cn(attachmentVariants({ size, orientation }), props.class)"
  >
    <slot />
  </div>
</template>
